import * as Sentry from '@sentry/vue'
import { defineNuxtPlugin } from '#app'
import * as pkg from '~/package.json'

export default defineNuxtPlugin((nuxtApp) => {
    if (process.env.NODE_ENV === 'development') {
        return
    }
    const release = `bbk-headless-app@v${pkg.version}`
    const environment = nuxtApp.$config.public.env
    const dsn = nuxtApp.$config.public.sentryDSN
    const { vueApp } = nuxtApp
    const router = useRouter()

    Sentry.init({
        app: [vueApp],
        dsn,
        release,
        environment,
        sampleRate: 1,
        tracesSampleRate: environment === 'prod' ? 0.1 : 1.0,
        replaysSessionSampleRate: environment === 'prod' ? 0.1 : 1.0,
        replaysOnErrorSampleRate: 1.0,
        integrations: [
            new Sentry.BrowserTracing({
                routingInstrumentation: Sentry.vueRouterInstrumentation(router),
            }),
            new Sentry.Replay({
                maskAllText: false,
                networkDetailAllowUrls: ['https://bridge.home-you.com/graphql'],
            }),
        ],
        beforeSend(event, hint) {
            // Check if it is an exception, and if so, log it.
            if (event.exception) {
                console.error(`[Exception handled by Sentry]: (${hint.originalException})`, { event, hint })
            }
            // Continue sending to Sentry
            return event
        },
    })

    vueApp.mixin(
        Sentry.createTracingMixins({
            trackComponents: true,
            timeout: 2000,
            hooks: ['activate', 'mount', 'update'],
        }),
    )

    Sentry.attachErrorHandler(vueApp, {
        logErrors: false,
        attachProps: true,
        trackComponents: true,
        timeout: 2000,
        hooks: ['activate', 'mount', 'update'],
    })

    return {
        provide: {
            sentrySetContext: Sentry.setContext,
            sentrySetUser: Sentry.setUser,
            sentrySetTag: Sentry.setTag,
            sentryAddBreadcrumb: Sentry.addBreadcrumb,
            sentryCaptureException: Sentry.captureException,
        },
    }
})
